<template>
	<div>
		<!-- ---------- -->

		<div class="footer_warp">
			<div class="footer_cont">
				<!-- top 右 -->
				<div class="footer_cont_l">
					<div>
						<img class="logo-img" src="../assets/img/nygl_logo.png" alt="" />
					</div>
					<div class="footer_cont_ewm">
						<div>
							<div class="footer_cont_l_border">
								<img src="../assets/img/ewm.jpg" alt="" />
							</div>
							<p>微信咨询</p>
						</div>
						<div>
							<div class="footer_cont_l_border">
								<img src="../assets/img/ewm.jpg" alt="" />
							</div>
							<p>微信咨询</p>
						</div>
					</div>
				</div>
				<!-- 上部 -->
				<div class="footer_cont_c">
					<!--上部 左 -->
					<div class="footer_cont_l_div">
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">解决方案</p>
							<ul class="footer_cont_l_ul">
								<li
									v-for="(item, index) in arrList1"
									:key="index"
									@click="toGuid(item.url, item.id)"
								>
									{{ item.title }}
								</li>

								<!-- <li>企业荣誉</li> -->
							</ul>
						</div>
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">产品中心</p>
							<ul class="footer_cont_l_ul">
								<li
									v-for="(item, index) in arrList2"
									:key="index"
									@click="toGuid(item.url, item.id)"
								>
									{{ item.title }}
								</li>

								<!-- <li>企业荣誉</li> -->
							</ul>
						</div>
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">新闻资讯</p>
							<ul class="footer_cont_l_ul">
								<li
									v-for="(item, index) in arrList3"
									:key="index"
									@click="toNews(item.url)"
								>
									{{ item.title }}
								</li>
							</ul>
						</div>
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">应用下载</p>
							<ul class="footer_cont_l_ul">
								<li
									v-for="(item, index) in arrList4"
									:key="index"
									@click="toPages(item.url)"
								>
									{{ item.title }}
								</li>
							</ul>
						</div>
						
						<div class="footer_cont_l_div_item">
							<p class="footer_cont_l_title">关于我们</p>
							<ul class="footer_cont_l_ul">
								<router-link to="jituangaikuo"><li>关于我们</li></router-link>
							</ul>
						</div>
						<div class="footer_cont_l_div_item2">
							<p class="footer_cont_l_title">联系我们</p>
							<ul class="footer_cont_l_ul">
								<router-link to="lianxi"><li>联系我们</li></router-link>
							</ul>
						</div>
					</div>
				</div>
				<!-- top 中 -->
				<div class="footer_cont_r">
					<p class="footer_cont_l_title">联系我们</p>
					<div class="footer_cont_l_ul">
						<div class="tel foot-contact fx">
							
								<i class="icon icon-dh"></i>
							<div class="tel-txt">
								<h4>0791-88866416</h4>
								<span>周一到周六8:30-17:30 (北京时间）</span>
							</div>
						</div>
						<div class="foot-contact fx ac">
							<i class="icon icon-dz"></i>
							<span>江西省南昌市赣江中大道1218号新地中心39层3908室</span>
						</div>
						<div class="foot-contact fx ac">
							<i class="icon icon-hz"></i>
							<span>jxznpower@163.com</span>
						</div>
					</div>
				</div>
				
			</div>
			<!-- 下部 -->
			<div class="footer_warp_btm">
				<p>
					<a style="color: #b2b6bf;" href="https://beian.miit.gov.cn" target="_blank">©&ensp;赣ICP备2024020452号-1</a>&emsp;江西正能智慧科技有限公司&emsp; 版权所有
				</p>
			</div>
		</div>

		<!-- --------- -->
	</div>
</template>

<script>
export default {
	name: "Footer",
	data() {
		return {
			arrList1: [
				{
					title: "能源管理系统",
					url: "/solution",
				},
				{
					title: "变压器监控运维理管平台",
					url: "/solution/power",
				},
				{
					title: "电缆安全监测系统",
					url: "/solution/cable",
				}
			],
			arrList2: [
				{
					title: "智能设备",
					url: "/product",
				},
				{
					title: "运维设备",
					url: "/product",
				},
				{
					title: "服务中心",
					url: "/product",
				}
			],
			arrList3: [
				{
					title: "公司动态",
					url: "/xinwen",
				},
				{
					title: "行业资讯",
					url: "/xinwen/MediaCoverage",
				},
				{
					title: "技术问题",
					url: "/xinwen/TradeNews",
				},
			],
			arrList4: [
				{
					title: "应用下载",
					url: "/download",
				}
			],
		};
	},

	mounted() {
		let _this = this;
		_this.$nextTick(function () {
			window.addEventListener("scroll", _this.handleScroll);
		});
	},

	methods: {
		// 锚点跳转
		toGuid(path, id) {
			localStorage.setItem("toId", id);
			this.$router.push(path);
			//查找存储的锚点id
			let Id = localStorage.getItem("toId");
			let toElement = document.getElementById(Id);
			//锚点存在跳转
			if (Id) {
				toElement.scrollIntoView();
				localStorage.setItem("toId", "");
			}
		},

		toPages(url) {
			this.$router.push(url);
		},
		toNews(url) {
			this.$router.push(url);
		},
	},
};
</script>
<style scoped>

.footer_cont_ewm{
	display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
	margin-top: 30px
}
.footer_warp {
	width: 100vw;
	background: #242632 url('../assets/img/footer_bg.png');
    background-size: 100% 100%;
    position: relative;
}
.footer_cont {
	width: 1400px;
	margin: 0 auto;
	display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}
.footer_cont_r {
	font-size: 16px;
	font-weight: 500;
	color: #dddddd;
	line-height: 22px;
	padding-top: 70px;
	margin-left: 80px;
}
.footer_cont_l_title {
	font-size: 16px;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: 500;
	color: #ffffff;
	line-height: 22px;
	width: 64px;
}
.footer_cont_l_ul {
	margin-top: 36px;
}
.footer_cont_l_ul li {
	font-size: 12px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	line-height: 22px;
	color: #ffffff;
	margin-top: 10px;
	cursor: pointer;
}
.footer_cont_l_ul li:hover{
	color: #0096a3;
}
.footer_cont_l_div {
	display: flex;
}
.footer_cont_l_div_item {
	margin-right: 60px;
}
.footer_cont_c {
	margin-top: 70px;
}
.logo-img{
	height: 80px;
	display: block;
	margin: 0 auto;
}
.address {
	width: 467px;
	font-size: 14px;
	font-family: "PingFangSC-Regular", "PingFang SC";
	font-weight: 400;
	color: #ffffff;
	line-height: 32px;
}
.footer_cont_l {
	margin-top: 70px;
	margin-right: 70px;
	width: 250px
}
.footer_cont_l p {
	text-align: center;
	font-size: 12px;
	font-family: "PingFangSC-Regular";
	font-weight: 400;
	color: #ffffff;
	line-height: 20px;
	margin-top: 12px;
}
.footer_cont_l_border {
	width: 105px;
	height: 105px;
	border: 1px solid #979797;
}
.footer_cont_l_border img {
	width: 90px;
	height: 90px;
	margin: 7px 7px;
}
.footer_warp_btm {
	width: 1400px;
	margin: 0 auto;
	margin-top: 56px;
	text-align: center;
	border-top: 1px solid #444444;
}
.footer_warp_btm p {
	font-size: 12px;
	font-weight: 400;
	color: #b2b6bf;
	line-height: 48px;
}
.foot-contact {
    margin-bottom: 10px;
	overflow: hidden;
}
.foot-contact h4 {
    font-size: 18px;
    color: #fff;
    margin-bottom: 5px;
}
.foot-contact span {
    font-size: 12px;
    color: #ccc;
}
.foot-contact .icon{
	float: left;
	display: block;
	margin-right: 16px
}
.foot-contact .tel-txt{
	float: left;
}
</style>
